import ConsumerRatings from './ConsumerRatings';

export default ConsumerRatings;
